import { orchestrator } from 'satcheljs';
import { saveToCloud } from '../actions/publicLazyActions';
import { saveToCloudInternal } from '../utils/saveToCloudFromSxS';

orchestrator(saveToCloud, saveToCloudInternal);
